import styled, { css } from 'styled-components';
import { ifNotProp, palette } from 'styled-tools';

import { minWidth, units } from '@calm-web/design-system';

export const FtueWrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	flex-grow: 1;
	width: 100%;
`;

export const ContentWrapper = styled.div<{ showHero?: boolean }>`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	${p =>
		p.showHero &&
		css`
			background: linear-gradient(180deg, rgba(56, 159, 230, 0) 57.58%, rgba(56, 159, 230, 0.35) 100%);
		`};
	padding-bottom: ${units(1.25)};

	${minWidth('desktop')} {
		flex-direction: row;
		padding: 0 ${units(3.56)};
		justify-content: center;
	}
`;

export const RevampContentWrapper = styled.main`
	overflow: auto;
	background: ${palette('gray0')};
	min-height: 100vh;

	${minWidth('desktop')} {
		flex-direction: row;
		justify-content: center;
	}
`;

export const ComponentWrapper = styled.div<{
	showHero?: boolean;
	isRevampRedempFlow?: boolean;
}>`
	width: 100%;

	${minWidth('desktop')} {
		width: unset;
		padding-bottom: ${p => (p.showHero && !p.isRevampRedempFlow ? units(2) : 0)};

		${ifNotProp(
			'isRevampRedempFlow',
			css`
				flex: 0 1 504px;
				margin-top: ${units(5)};
			`,
		)}
	}
`;

export const LoaderContainer = styled.div`
	height: 100vh;
`;
